/** Minimum word count a page's real content must have before we consider it
 *  "substantive" enough to show an ad slot next to it — keeps ad placements
 *  off thin/empty content, per AdSense policy on low-value pages. */
const MIN_WORDS_FOR_ADS = 120;

export function hasEnoughContentForAds(...textParts: (string | undefined | null)[]): boolean {
  const words = textParts
    .filter((t): t is string => Boolean(t))
    .join(" ")
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
  return words >= MIN_WORDS_FOR_ADS;
}
